/**
 * Norativ Product Page — JavaScript v3.2
 * Upload to: assets/norativ-product-page.js
 */
(function (global) {
    'use strict';

    /* ── Defer helper ────────────────────────────────────── */
    var deferWork = typeof requestIdleCallback === 'function'
        ? requestIdleCallback
        : function(cb) { setTimeout(cb, 0); };

    /* ── NorativPP class ─────────────────────────────────── */
    function NorativPP(sectionId) {
        this.sid = sectionId;
        this.root = document.getElementById('npp-' + sectionId);
        if (!this.root) return;

        var key = 'nppData_' + sectionId.replace(/-/g, '_');
        var raw = global[key] || {};
        this.swatchData = raw.data || {};
        this.variants = raw.variants || [];

        // Track current selections
        this.curColor = null;
        this.curSize = null;

        /* Critical path — runs immediately */
        this._initLayoutMoves();
        this._initGallery();
        this._initInteractions();
        this._initStickyBar();
        this._initOnLoad();

        /* Non-critical — deferred to free main thread */
        var self = this;
        deferWork(function() {
            self._initAccordions();
            self._initModals();
            self._initLightbox();
            self._initTestimonialRotator();
            self._optimizeImages();
            
            // Preload all swatches in the background
            if (self.swatchData) {
                for (var pos in self.swatchData) {
                    self._preloadPackSwatches(pos);
                }
            }
        });
    }

    /* ── Image performance optimisation ─────────────────── */
    NorativPP.prototype._optimizeImages = function () {
        if (!this.root) return;
        var allImages = this.root.querySelectorAll('img');
        var gallerySlides = this.root.querySelectorAll('.pdp-gallery__slide img, .npp-slide img');
        var firstGalleryImg = gallerySlides.length ? gallerySlides[0] : null;

        allImages.forEach(function(img) {
            if (img === firstGalleryImg) {
                /* First gallery image: high priority, sync decode */
                img.setAttribute('fetchpriority', 'high');
                img.removeAttribute('loading');
            } else {
                /* Below-fold images: lazy + async decode */
                if (!img.hasAttribute('loading')) img.setAttribute('loading', 'lazy');
                img.setAttribute('decoding', 'async');
            }
        });
    };

    NorativPP.prototype._initGallery = function () {
        var self = this;
        this.slidesEl = document.getElementById('npp-slides-' + this.sid);
        this.counterEl = document.getElementById('npp-counter-' + this.sid);
        if (!this.slidesEl) return;

        this.slidesEl.addEventListener('scroll', function () { self._syncCounter(); }, { passive: true });


    };

    NorativPP.prototype._syncCounter = function () {
        if (!this.counterEl || !this.slidesEl) return;
        var slideW = this.slidesEl.offsetWidth;
        if (slideW <= 0) return;
        var cur = Math.round(this.slidesEl.scrollLeft / slideW);
        var currentSpan = this.counterEl.querySelector('.npp-counter-current');
        if (currentSpan) currentSpan.textContent = cur + 1;

        // Show/Hide badges only on first slide
        var badges = this.root.querySelectorAll('.pdp-gallery__guarantee-badge, .pdp-gallery__pack-pill');
        badges.forEach(function(badge) {
            if (cur === 0) {
                badge.style.opacity = '1';
                badge.style.visibility = 'visible';
                badge.style.pointerEvents = 'none';
            } else {
                badge.style.opacity = '0';
                badge.style.visibility = 'hidden';
                badge.style.pointerEvents = 'none';
            }
        });
    };

    NorativPP.prototype.nextSlide = function () {
        if (!this.slidesEl) return;
        var w = this.slidesEl.offsetWidth / 2;
        this.slidesEl.scrollBy({ left: w * 2, behavior: 'smooth' });
    };

    NorativPP.prototype.prevSlide = function () {
        if (!this.slidesEl) return;
        var w = this.slidesEl.offsetWidth / 2;
        this.slidesEl.scrollBy({ left: -(w * 2), behavior: 'smooth' });
    };

    NorativPP.prototype.setGalleryPhotos = function (photos) {
        if (!this.slidesEl) return;
        var self = this;

        // Remove existing dynamic slides
        this.slidesEl.querySelectorAll('.npp-slide--dyn').forEach(function (s) { s.remove(); });

        // Show all default slides
        var defaultSlides = this.slidesEl.querySelectorAll('.pdp-gallery__slide, .npp-slide');
        defaultSlides.forEach(function (s) { s.style.display = ''; });

        if (photos && photos.length) {
            // Prepend swatch photos at the beginning
            photos.reverse().forEach(function (url) {
                var div = document.createElement('div');
                div.className = 'pdp-gallery__slide npp-slide--dyn';
                var firstExisting = self.slidesEl.querySelector('.pdp-gallery__slide');
                if (firstExisting && firstExisting.style.aspectRatio) {
                    div.style.aspectRatio = firstExisting.style.aspectRatio;
                }
                var img = document.createElement('img');
                img.src = url;
                img.alt = '';
                img.loading = 'eager';
                img.style.width = '100%';
                img.style.height = '100%';
                img.style.objectFit = 'cover';
                div.appendChild(img);
                // Insert at start
                this.slidesEl.insertBefore(div, this.slidesEl.firstChild);
            }, this);
        }

        // Rebuild counter
        if (this.counterEl) {
            var totalSlides = this.slidesEl.querySelectorAll('.pdp-gallery__slide, .npp-slide').length;
            var totalSpan = this.counterEl.querySelector('.npp-counter-total');
            if (totalSpan) totalSpan.textContent = totalSlides;
            if (totalSlides <= 1) {
                this.counterEl.style.display = 'none';
            } else {
                this.counterEl.style.display = 'inline-block';
            }
        }

        // Scroll to the start so the new (or old) first photo is visible
        this.slidesEl.scrollTo({ left: 0, behavior: 'instant' });
        try { this._syncDots(); } catch(e) {}
    };

    /* ── Dot sync (no-op placeholder) ────────────────── */
    NorativPP.prototype._syncDots = function () {};

    /* ── Layout moves (JS-only DOM relocation) ────────── */
    NorativPP.prototype._initLayoutMoves = function () {
        if (!this.root) return;

        /* Move .pdp-fi-strip from above gallery to below the price block */
        var iconStrip = this.root.querySelector('.pdp-fi-strip');
        var uspList   = this.root.querySelector('.pdp-usps');
        var buyHeader = this.root.querySelector('.pdp-buy__header');

        if (iconStrip && buyHeader) {
            /* Hide the USP bullet list */
            if (uspList) uspList.style.display = 'none';

            /* Insert icon strip right after the buy header (where USPs were) */
            if (buyHeader.nextSibling) {
                buyHeader.parentNode.insertBefore(iconStrip, buyHeader.nextSibling);
            } else {
                buyHeader.parentNode.appendChild(iconStrip);
            }

            /* Make it visible now that it's in the correct position */
            iconStrip.style.setProperty('display', 'flex', 'important');
        }
    };

    /* ── Interactions (Size & Pack) ────────────────────── */
    NorativPP.prototype._initInteractions = function () {
        var self = this;
        if (!this.root) return;

        // 1. Size buttons
        var sizeBtns = this.root.querySelectorAll('.npp-size-btn');
        sizeBtns.forEach(function (btn) {
            btn.removeAttribute('onclick');
            btn.addEventListener('click', function (e) {
                self.selectSize(btn);
            });
        });

        // 2. Pack pills
        var packPills = this.root.querySelectorAll('.pdp-pack--pill');
        packPills.forEach(function (pill) {
            pill.removeAttribute('onclick');

            // Preload on hover / touchstart for instant switch
            pill.addEventListener('mouseenter', function (e) {
                var pos = pill.getAttribute('data-pack');
                self._preloadPackSwatches(pos);
            });
            pill.addEventListener('touchstart', function (e) {
                var pos = pill.getAttribute('data-pack');
                self._preloadPackSwatches(pos);
            }, { passive: true });

            pill.addEventListener('click', function (e) {
                var pos = pill.getAttribute('data-pack');
                self.selectPack(pill, pos);
            });
        });
    };

    /* ── Swatches ────────────────────────────────────────── */
        NorativPP.prototype.renderSwatches = function (packPos) {
        var packData = this.swatchData[packPos] || {};
        var grid = document.getElementById('npp-swgrid-' + this.sid);
        var wrap = document.getElementById('npp-swwrap-' + this.sid);
        var namesEl = document.getElementById('npp-swnames-' + this.sid);
        if (!grid) return;
        grid.innerHTML = '';

        var nums = Object.keys(packData).sort(function (a, b) { return +a - +b; });
        if (!nums.length) {
            if (wrap) wrap.classList.remove('visible');
            this.setGalleryPhotos([]);
            this.curColor = null;
            this._syncVariant();
            return;
        }
        if (wrap) wrap.classList.add('visible');

        var activeIdx = 0;
        var activeEl = null;
        var currentPath = window.location.pathname;

        nums.forEach(function (n, i) {
            var sw = packData[n];
            var div = document.createElement('div');
            
            // Determine if this swatch matches the current product URL
            var isCurrent = (sw.link && (currentPath === sw.link || window.location.href.includes(sw.link)));
            if (isCurrent) {
                activeIdx = i;
                activeEl = div;
            }

            div.className = 'npp-swatch';
            div.title = sw.name;
            div.setAttribute('role', 'button');
            div.setAttribute('tabindex', '0');
            div.setAttribute('aria-label', sw.name);

            if (sw.bs) {
                var badge = document.createElement('div');
                badge.className = 'npp-bs-badge';
                badge.innerText = '🔥 BEST SELLER';
                div.appendChild(badge);
            }

            if (sw.img) {
                var img = document.createElement('img'); img.src = sw.img; img.alt = sw.name;
                div.appendChild(img);
            } else {
                var span = document.createElement('span'); span.className = 'npp-swatch-empty';
                div.appendChild(span);
            }

            div.addEventListener('click', this._mkSwatchCb(div, sw, grid, namesEl));
            div.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); div.click(); } });
            grid.appendChild(div);
        }, this);

        // Select the correct swatch on load
        if (!activeEl) activeEl = grid.firstChild;
        var activeSw = packData[nums[activeIdx]];
        this._pickSwatch(activeEl, activeSw, grid, namesEl, false);

        // Scroll carousel so selected swatch is visible and centered
        if (activeEl && grid) {
            requestAnimationFrame(function() {
                var el = activeEl;
                var container = grid;
                var elLeft = el.offsetLeft;
                var elWidth = el.offsetWidth;
                var containerWidth = container.offsetWidth;
                container.scrollLeft = elLeft - (containerWidth / 2) + (elWidth / 2);
            });
        }
    };

    NorativPP.prototype._mkSwatchCb = function (div, sw, grid, namesEl) {
        var self = this;
        return function () { self._pickSwatch(div, sw, grid, namesEl, true); };
    };

    NorativPP.prototype._pickSwatch = function (div, sw, grid, namesEl, isManual) {
        var self = this;
        if (grid) grid.querySelectorAll('.npp-swatch').forEach(function (c) { c.classList.remove('selected'); });
        if (div) div.classList.add('selected');
        if (namesEl) namesEl.textContent = sw.name;

        this.curColor = sw.name;
        this.setGalleryPhotos(sw.photos && sw.photos.length ? sw.photos : []);
        this._syncVariant();

        if (isManual && sw.link && sw.link !== '#' && sw.link !== '') {
            /* Step 2: get destination URL from swatch */
            var swatchUrl = String(sw.link);
            
            /* Step 3: replace slug in currentPackUrl with slug from swatchUrl */
            var currentPackUrl = this.currentPackUrl || window.location.href;
            
            /* Save current pack to localStorage so it persists after swatch navigation + refresh */
            try { localStorage.setItem('lastSelectedPack', currentPackUrl); } catch(e) {}

            var swatchSlugMatch = swatchUrl.match(/\/products\/([^\/\?]+)/);
            var newUrl = currentPackUrl;
            
            if (swatchSlugMatch) {
                var newSlug = swatchSlugMatch[1];
                newUrl = currentPackUrl.replace(/\/products\/([^\/\?]+)/, '/products/' + newSlug);
            }

            /* Save scroll position */
            try { sessionStorage.setItem('npp_scroll_y', String(window.scrollY || window.pageYOffset)); } catch(e) {}
            
            /* Navigate */
            window.location.assign(newUrl);
        }
    };

    /* ── Pack selection ──────────────────────────────────── */
        /* ── Size selection ──────────────────────────────────── */
    NorativPP.prototype.selectSize = function (btn) {
        if (btn.classList.contains('soldout') || btn.disabled) return;
        var parent = btn.parentElement;
        if (parent) parent.querySelectorAll('.pdp-sz, .npp-size-btn').forEach(function (b) { 
            b.classList.remove('selected'); 
            b.classList.remove('is-active'); 
        });
        btn.classList.add('selected');
        btn.classList.add('is-active');

        this.curSize = btn.dataset.val || btn.dataset.size;
        this._syncVariant();
    };

    NorativPP.prototype._syncVariant = function () {
        var match = null;
        var color = this.curColor;
        var size = this.curSize;

        for (var i = 0; i < this.variants.length; i++) {
            var v = this.variants[i];
            var opts = [v.opt1, v.opt2, v.opt3].filter(Boolean);

            // Check if variant matches both Color and Size (if they exist)
            var matchesColor = !color || opts.indexOf(color) !== -1;
            var matchesSize = !size || opts.indexOf(size) !== -1;

            if (matchesColor && matchesSize) { match = v; break; }
        }

        // If no exact match (dual filter), try to just match size at least (fallback)
        if (!match && size) {
            for (var j = 0; j < this.variants.length; j++) {
                var v2 = this.variants[j];
                var opts2 = [v2.opt1, v2.opt2, v2.opt3].filter(Boolean);
                if (opts2.indexOf(size) !== -1) { match = v2; break; }
            }
        }

        if (!match) return;

        var vidEl = document.getElementById('npp-vid-' + this.sid);
        var atcBtn = document.getElementById('npp-atc-' + this.sid);
        var priceEl = document.getElementById('npp-price-' + this.sid);
        var stickyPr = document.getElementById('npp-sticky-price-' + this.sid);
        var stickyVar = document.getElementById('npp-sticky-variant-' + this.sid);

        if (vidEl) vidEl.value = match.id;
        if (atcBtn) {
            atcBtn.disabled = !match.available;
            atcBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
        }
        if (priceEl && match.price) priceEl.textContent = match.price;
        if (stickyPr && match.price) stickyPr.textContent = match.price;

        /* Update sticky bar display */
        if (stickyVar) {
            var text = [];
            if (color) text.push(color);
            if (size) text.push('Size: ' + size);
            stickyVar.textContent = text.join(' / ');
        }

        // Sync sticky bar size buttons to always reflect current main selection
        var stickyBtns = document.querySelectorAll('.npp-sz-mini[data-sid="' + this.sid + '"]');
        stickyBtns.forEach(function (b) {
            var isMatch = (b.dataset.size === size);
            b.classList.toggle('selected', isMatch);
            b.classList.toggle('is-active', isMatch);
        });
    };

    /* ── Quantity ────────────────────────────────────────── */
        /* ── Accordions ─────────────────────────────────────── */
    NorativPP.prototype._initAccordions = function () {
        if (!this.root) return;
        this.root.querySelectorAll('.npp-accordion').forEach(function (acc) {
            var btn = acc.querySelector('.npp-accordion-btn');
            if (btn) btn.addEventListener('click', function () {
                var isOpen = acc.classList.toggle('open');
                btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            });
        });
    };

    /* ── Modals ─────────────────────────────────────────── */
    NorativPP.prototype._initModals = function () {
        if (!this.root) return;
        this.root.querySelectorAll('.npp-modal-overlay').forEach(function (overlay) {
            overlay.addEventListener('click', function (e) { if (e.target === overlay) overlay.classList.remove('open'); });
        });
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') document.querySelectorAll('.npp-modal-overlay.open').forEach(function (m) { m.classList.remove('open'); });
        });
    };

    /* ── Sticky bar ─────────────────────────────────────── */
    NorativPP.prototype._initStickyBar = function () {
        var atcEl = document.getElementById('npp-byp-btn-' + this.sid) || document.getElementById('npp-atc-' + this.sid);
        var stickyEl = document.getElementById('npp-sticky-' + this.sid);
        if (!atcEl || !stickyEl) return;

        if (stickyEl.dataset.stickyMove) {
            document.body.appendChild(stickyEl);
        }

        var visible = false;

        var show = function () {
            if (visible) return;
            visible = true;
            stickyEl.classList.add('visible');
            stickyEl.setAttribute('aria-hidden', 'false');
        };
        var hide = function () {
            if (!visible) return;
            visible = false;
            stickyEl.classList.remove('visible');
            stickyEl.setAttribute('aria-hidden', 'true');
        };

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
                    show();
                } else {
                    hide();
                }
            });
        }, { threshold: 0 });

        var r = atcEl.getBoundingClientRect();
        if (r.bottom < 0) show(); else hide();

        observer.observe(atcEl);

        // --- Custom sticky modifications ---
        var stickyBtn = document.getElementById('npp-sticky-atc-' + this.sid);
        if (stickyBtn) {
            stickyBtn.removeAttribute('onclick');
            stickyBtn.removeAttribute('style'); // Clear inline bg/color
            stickyBtn.textContent = 'CONTINUE TO STEP 2';
            
            var selfSid = this.sid;
            stickyBtn.addEventListener('click', function(e) {
                e.preventDefault();
                var step2Btn = document.getElementById('npp-byp-btn-' + selfSid);
                if (step2Btn) {
                    step2Btn.click();
                } else {
                    var sizeRow = document.querySelector('.npp-size-grid');
                    var colorRow = document.querySelector('#npp-swwrap-' + selfSid) || document.querySelector('.npp-swatch-grid');
                    var scrollTarget = document.querySelector('.pdp-row') || sizeRow || colorRow;
                    
                    if (scrollTarget) {
                        var y = scrollTarget.getBoundingClientRect().top + window.scrollY - 120;
                        window.scrollTo({ top: y, behavior: 'smooth' });
                    }
                }
            });
        }
        
        // Remove size selector completely from sticky bar DOM
        var stickyPick = document.querySelector('#npp-sticky-' + this.sid + ' .npp-sticky-pick');
        if (stickyPick) {
            stickyPick.parentNode.removeChild(stickyPick);
        }
    };

    NorativPP.prototype._initTestimonialRotator = function () {
        var el = document.getElementById('npp-tm-' + this.sid);
        if (!el) return;
        var slides = el.querySelectorAll('.npp-tm-slide');
        if (slides.length < 2) return;
        var cur = 0;
        setInterval(function () {
            slides[cur].style.opacity = '0';
            setTimeout(function () {
                slides[cur].style.display = 'none';
                cur = (cur + 1) % slides.length;
                slides[cur].style.display = 'flex';
                requestAnimationFrame(function () {
                    slides[cur].style.opacity = '1';
                });
            }, 400);
        }, 5000);
    };

    /* ── Reviews carousel scroll ────────────────────────── */
    NorativPP.prototype.scrollReviews = function (dir) {
        var el = document.getElementById('npp-rv-scroll-' + this.sid);
        if (!el) return;
        var card = el.querySelector('.npp-review-card');
        var w = card ? card.offsetWidth + 12 : 280;
        el.scrollBy({ left: dir * w * 2, behavior: 'smooth' });
    };

    /* ── Init on load ────────────────────────────────────── */
    NorativPP.prototype._initOnLoad = function () {
        var row = document.getElementById('npp-packs-' + this.sid);

        if (row) {
            var card = null;
            var allPills = row.querySelectorAll('.pdp-pack, .pdp-pack--pill, .npp-pack-card');

            /* Match current page URL pathname against each pill's link pathname */
            var curPath = window.location.pathname;
            allPills.forEach(function(pill) {
                var link = pill.getAttribute('data-link') || pill.getAttribute('data-url') || pill.getAttribute('href') || '';
                if (!link) return;
                var linkPath = link;
                try { linkPath = new URL(link, window.location.origin).pathname; } catch(e) {
                    var qi = link.indexOf('?'); if (qi > -1) linkPath = link.substring(0, qi);
                }
                if (linkPath && curPath === linkPath) {
                    card = pill;
                }
            });

            /* Fallback: check localStorage for last selected pack */
            if (!card) {
                var saved = null;
                try { saved = localStorage.getItem('lastSelectedPack'); } catch(e) {}
                if (saved) {
                    /* Extract pathname from saved value for comparison */
                    var savedPath = saved;
                    try { savedPath = new URL(saved, window.location.origin).pathname; } catch(e) {
                        var qi2 = saved.indexOf('?'); if (qi2 > -1) savedPath = saved.substring(0, qi2);
                    }
                    allPills.forEach(function(pill) {
                        var link = pill.getAttribute('data-link') || pill.getAttribute('data-url') || pill.getAttribute('href') || '';
                        if (!link) return;
                        var linkPath = link;
                        try { linkPath = new URL(link, window.location.origin).pathname; } catch(e) {
                            var qi3 = link.indexOf('?'); if (qi3 > -1) linkPath = link.substring(0, qi3);
                        }
                        if (linkPath && linkPath === savedPath) { card = pill; }
                    });
                }
            }

            /* Fallback: Liquid-set npp-active or early JS selection */
            if (!card) card = row.querySelector('.pdp-pack.npp-active') || row.querySelector('.pdp-pack--pill.npp-active') || row.querySelector('.npp-pack-card.selected');

            /* Last resort: first pill */
            if (!card) card = allPills[0];

            if (card) {
                allPills.forEach(function (c) {
                    c.classList.remove('selected');
                    c.classList.remove('is-active');
                    c.classList.remove('npp-active');
                });
                card.classList.add('selected');
                card.classList.add('npp-active');
                
                /* Step 1: save currently selected pack pill URL to currentPackUrl */
                this.currentPackUrl = card.getAttribute('data-link') || card.getAttribute('data-url') || card.getAttribute('href') || window.location.href;

                /* Update header price-per-shirt exactly as set in admin */
                var ppi = card.dataset.ppi;
                var ppiEl = this.root ? this.root.querySelector('.js-ppi') : null;
                if (ppiEl && ppi && ppi.trim() !== '') {
                    ppiEl.textContent = ppi;
                    ppiEl.style.display = '';
                }
                
                this.renderSwatches(card.dataset.pack);
            }
        } else {
            this.currentPackUrl = window.location.href;
            this.renderSwatches('1');
        }

        var firstSz = this.root ? this.root.querySelector('.pdp-sz.is-active, .npp-size-btn.selected') : null;
        if (firstSz) {
            this.curSize = firstSz.dataset.val || firstSz.dataset.size;
            this._syncVariant();
        }

        /* Step 6: restore scroll position and clear it */
        try {
            var savedY = sessionStorage.getItem('npp_scroll_y');
            if (savedY !== null) {
                var y = parseInt(savedY, 10);
                if (!isNaN(y) && y > 0) {
                    window.scrollTo(0, y);
                }
                sessionStorage.removeItem('npp_scroll_y');
            }
        } catch(e) {}

        /* Price Display Logic: prominence for total price if PPI is empty */
        var ppiEl = this.root ? this.root.querySelector('.js-ppi') : null;
        var totalEl = this.root ? this.root.querySelector('.js-total') : null;
        if (ppiEl && (!ppiEl.textContent || ppiEl.textContent.trim() === '')) {
            ppiEl.style.setProperty('display', 'none', 'important');
            if (totalEl) {
                totalEl.style.setProperty('font-size', '28px', 'important');
                totalEl.style.setProperty('font-weight', '900', 'important');
                totalEl.style.setProperty('color', '#111111', 'important');
            }
        }
    };

    /* ── Lightbox Gallery ────────────────────────────────── */
    NorativPP.prototype._initLightbox = function () {
        var self = this;
        if (!this.root || this.root._lbInit) return;
        this.root._lbInit = true;

        // Inject Styles dynamically to avoid touching CSS files
        var styleId = 'npp-lb-styles';
        if (!document.getElementById(styleId)) {
            var st = document.createElement('style');
            st.id = styleId;
            st.textContent = [
                '.npp-lb { position: fixed; inset: 0; background: rgba(0,0,0,0.85); z-index: 99999; display: none; align-items: center; justify-content: center; user-select: none; -webkit-user-select: none; backdrop-filter: blur(4px); -webkit-backdrop-filter: blur(4px); }',
                '.npp-lb.is-open { display: flex; }',
                '.npp-lb-close { position: absolute; top: 0; right: 0; padding: 24px; color: #fff; font-size: 32px; font-weight: 900; cursor: pointer; z-index: 100001; line-height: 1; }',
                '.npp-lb-content { position: relative; width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; overflow: hidden; }',
                '.npp-lb-img { max-width: 95%; max-height: 95%; object-fit: contain; box-shadow: 0 0 40px rgba(0,0,0,0.5); pointer-events: auto; transition: transform 0.3s ease; }',
                '.npp-lb-nav { position: absolute; top: 50%; transform: translateY(-50%); color: #fff; font-size: 48px; font-weight: 100; cursor: pointer; padding: 40px; z-index: 100001; background: none; border: none; opacity: 0.7; transition: opacity 0.2s; }',
                '.npp-lb-nav:hover { opacity: 1; }',
                '.npp-lb-prev { left: 0; }',
                '.npp-lb-next { right: 0; }',
                '.npp-lb-prog { position: absolute; bottom: 40px; left: 50%; transform: translateX(-50%); background: rgba(255,255,255,0.15); backdrop-filter: blur(10px); color: #fff; padding: 8px 20px; border-radius: 30px; font-size: 13px; font-weight: 600; z-index: 100001; border: 1px solid rgba(255,255,255,0.1); }',
                '@media (max-width: 768px) { .npp-lb-nav { display: none; } .npp-lb-prog { bottom: 20px; } .npp-lb-close { padding: 16px; font-size: 28px; } }'
            ].join('\n');
            document.head.appendChild(st);
        }

        // Create Overlay DOM
        var overlay = document.createElement('div');
        overlay.className = 'npp-lb';
        overlay.innerHTML = 
            '<div class="npp-lb-close" title="Close">✕</div>' +
            '<button class="npp-lb-nav npp-lb-prev" title="Previous">‹</button>' +
            '<div class="npp-lb-content"><img class="npp-lb-img" src="" alt=""></div>' +
            '<button class="npp-lb-nav npp-lb-next" title="Next">›</button>' +
            '<div class="npp-lb-prog"></div>';
        document.body.appendChild(overlay);

        var lbImg = overlay.querySelector('.npp-lb-img');
        var lbProg = overlay.querySelector('.npp-lb-prog');
        var curIdx = 0;
        var images = [];
        var animating = false;

        var update = function(idx, dir) {
            if (images.length === 0 || animating) return;
            var oldIdx = curIdx;
            if (idx < 0) idx = images.length - 1;
            if (idx >= images.length) idx = 0;
            if (idx === oldIdx && overlay.classList.contains('is-open')) return;
            
            curIdx = idx;
            lbProg.textContent = (curIdx + 1) + ' of ' + images.length;

            if (!overlay.classList.contains('is-open')) {
                lbImg.src = images[curIdx];
                return;
            }

            // Sliding animation
            animating = true;
            var content = overlay.querySelector('.npp-lb-content');
            var currentImg = lbImg;
            var nextImg = document.createElement('img');
            nextImg.className = 'npp-lb-img';
            nextImg.src = images[curIdx];
            nextImg.style.position = 'absolute';
            
            var moveOut = dir === 'next' ? '-100%' : '100%';
            var moveIn = dir === 'next' ? '100%' : '-100%';

            nextImg.style.transform = 'translateX(' + moveIn + ')';
            content.appendChild(nextImg);

            // Force reflow
            nextImg.offsetWidth;

            currentImg.style.transform = 'translateX(' + moveOut + ')';
            nextImg.style.transform = 'translateX(0)';

            setTimeout(function() {
                currentImg.src = nextImg.src;
                // Instantly reset transform for the real image element
                currentImg.style.transition = 'none';
                currentImg.style.transform = 'translateX(0)';
                // Re-enable transition after reset
                currentImg.offsetWidth;
                currentImg.style.transition = '';
                
                nextImg.remove();
                animating = false;
            }, 300);
        };

        var open = function(srcs, startIdx) {
            images = srcs;
            if (images.length === 0) return;
            update(startIdx);
            overlay.classList.add('is-open');
            document.body.style.overflow = 'hidden';
        };

        var close = function() {
            overlay.classList.remove('is-open');
            document.body.style.overflow = '';
            animating = false;
        };

        // Event Listeners for Opening
        this.root.addEventListener('click', function(e) {
            var slide = e.target.closest('.pdp-gallery__slide, .npp-slide');
            if (!slide) return;
            if (e.target.closest('button, .pdp-gallery__guarantee-badge, .pdp-gallery__pack-pill')) return;
            var targetImg = slide.querySelector('img');
            if (!targetImg) return;

            var allSlides = Array.from(self.root.querySelectorAll('.pdp-gallery__slide, .npp-slide')).filter(function(s) {
                return s.style.display !== 'none' && s.querySelector('img');
            });
            var srcs = allSlides.map(function(s) { return s.querySelector('img').src; });
            var idx = srcs.indexOf(targetImg.src);
            open(srcs, idx >= 0 ? idx : 0);
        });

        // Overlay Controls
        overlay.querySelector('.npp-lb-close').addEventListener('click', close);
        overlay.querySelector('.npp-lb-prev').addEventListener('click', function(e) { e.stopPropagation(); update(curIdx - 1, 'prev'); });
        overlay.querySelector('.npp-lb-next').addEventListener('click', function(e) { e.stopPropagation(); update(curIdx + 1, 'next'); });
        
        overlay.addEventListener('click', function(e) { 
            if (e.target === overlay || e.target.classList.contains('npp-lb-content')) close(); 
        });

        // Swipe support (Mobile)
        var tsX = 0;
        var tsY = 0;
        overlay.addEventListener('touchstart', function(e) { 
            tsX = e.changedTouches[0].screenX; 
            tsY = e.changedTouches[0].screenY;
        }, {passive: true});
        overlay.addEventListener('touchend', function(e) {
            var teX = e.changedTouches[0].screenX;
            var teY = e.changedTouches[0].screenY;
            if (Math.abs(teX - tsX) > Math.abs(teY - tsY)) {
                if (tsX - teX > 40) update(curIdx + 1, 'next');
                if (teX - tsX > 40) update(curIdx - 1, 'prev');
            }
        }, {passive: true});

        // Key support
        document.addEventListener('keydown', function(e) {
            if (!overlay.classList.contains('is-open')) return;
            if (e.key === 'Escape') close();
            if (e.key === 'ArrowRight') update(curIdx + 1, 'next');
            if (e.key === 'ArrowLeft') update(curIdx - 1, 'prev');
        });
    };

    /* ── Registry & global API ───────────────────────────── */
    var registry = {};

    function get(sid) { return registry[sid] || null; }

    global.nppNext = function (sid) { var i = get(sid); if (i) i.nextSlide(); };
    global.nppPrev = function (sid) { var i = get(sid); if (i) i.prevSlide(); };
        global.nppSize = function (btn, val, sid) { var i = get(sid); if (i) i.selectSize(btn); };
        global.nppRvScroll = function (dir, sid) { var i = get(sid); if (i) i.scrollReviews(dir); };
    global.nppOpenM = function (id) { var el = document.getElementById(id); if (el) el.classList.add('open'); };
    global.nppCloseM = function (id) { var el = document.getElementById(id); if (el) el.classList.remove('open'); };

    global.nppSubmit = function (sid) {
        var btn = document.getElementById('npp-atc-' + sid);
        if (btn && !btn.disabled) {
            btn.click();
        } else {
            var form = document.getElementById('npp-form-' + sid);
            if (form) form.submit();
        }
    };

    /* Sticky bar size button handler */
    global.nppStickySz = function (btn) {
        var sid = btn.dataset.sid;
        var size = btn.dataset.size;
        if (!sid || !size || btn.disabled) return;

        var inst = get(sid);
        if (!inst) return;

        // Find the matching main size button (try data-val then data-size)
        var root = document.querySelector('[data-npp-section="' + sid + '"]');
        var mainBtn = null;
        if (root) {
            mainBtn = root.querySelector('.npp-size-btn[data-val="' + size + '"]')
                   || root.querySelector('.npp-size-btn[data-size="' + size + '"]');
        }

        if (mainBtn && !mainBtn.disabled && !mainBtn.classList.contains('soldout')) {
            // Deselect all main size buttons
            var parent = mainBtn.parentElement;
            if (parent) parent.querySelectorAll('.pdp-sz, .npp-size-btn').forEach(function (b) {
                b.classList.remove('selected');
                b.classList.remove('is-active');
            });
            mainBtn.classList.add('selected');
            mainBtn.classList.add('is-active');
        }

        // Update sticky bar buttons visually
        document.querySelectorAll('.npp-sz-mini[data-sid="' + sid + '"]').forEach(function (b) {
            var isMatch = (b.dataset.size === size);
            b.classList.toggle('selected', isMatch);
            b.classList.toggle('is-active', isMatch);
        });

        // Update variant and form
        inst.curSize = size;
        inst._syncVariant();
    };


    function initAll() {
        document.querySelectorAll('[data-npp-section]').forEach(function (el) {
            var sid = el.dataset.nppSection;
            if (sid && !registry[sid]) {
                registry[sid] = new NorativPP(sid);
            }
        });
    }

    // Immediate init
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAll);
    } else {
        initAll();
    }

    // Theme editor support
    document.addEventListener('shopify:section:load', function (e) {
        var sid = e.detail && e.detail.sectionId;
        if (sid) {
            registry[sid] = new NorativPP(sid);
        }
    });

    // Global exposed init for backup
    global.nppInit = initAll;

}(window));


/* ============================================================
   NORATIV CRO BOOSTERS v2.0  — Theme-Editor Driven
   All config read from data-cro-* on #npp-root (set by Liquid)
   ============================================================ */
(function () {
  'use strict';

  function $r(arr){ return arr[Math.floor(Math.random()*arr.length)]; }
  function $q(sel){ return document.querySelector(sel); }
  function split(s){ return s ? s.split(',').map(function(x){ return x.trim(); }).filter(Boolean) : []; }

  function buildCFG() {
    var root = $q('[data-npp-section]');
    var d    = root ? root.dataset : {};
    return {
      rootEl:         root,
      timerEnabled:   d.croTimerEnabled                 !== 'false',
      timerMin:       parseInt(d.croTimerMin,10)        || 12,
      timerKey:       'npp_cro_end',
      timerLabel:     d.croTimerLabel                   || 'Cart reserved for:',
      proofEnabled:   d.croProof                        !== 'false',
      proofDelay:     (parseInt(d.croProofDelay,10)     || 8)  * 1000,
      proofInterval:  (parseInt(d.croProofInterval,10)  || 20) * 1000,
      proofDuration:  5500,
      progressBar:    d.croProgress                     !== 'false',
      stickyDelay:    parseInt(d.croStickyDelay,10)     || 1600,
      sizeHesMs:      4500,
      atcSuccess:     '✓ Added to cart!',
      atcDuration:    2200,
      names:    split(d.croProofNames).length    ? split(d.croProofNames)    : ['James (New York)','Lucas (London)','Ethan (Sydney)','Noah (Toronto)','Liam (Amsterdam)','Oliver (Berlin)'],
      products: split(d.croProofProducts).length ? split(d.croProofProducts) : ['Essential 6-Pack','3-Pack Black','3-Pack White','Premium 4-Pack','6-Pack Mix'],
      times:    ['2 min ago','4 min ago','7 min ago','11 min ago','15 min ago']
    };
  }

  /* ── 1. Scroll Progress Bar ────────────────────────────────── */
  function initProgressBar(CFG) {
    if (!CFG.progressBar) return;
    var bar = document.createElement('div');
    bar.className = 'npp-cro-progress';
    if (CFG.rootEl) {
      CFG.rootEl.appendChild(bar);
    } else {
      document.body.appendChild(bar);
    }
    var raf;
    window.addEventListener('scroll', function(){
      if (raf) return;
      raf = requestAnimationFrame(function(){
        raf = null;
        var total = document.body.scrollHeight - window.innerHeight;
        bar.style.width = (total > 0 ? Math.min(100, window.scrollY / total * 100) : 0) + '%';
      });
    }, { passive: true });
  }

  /* ── 2. Urgency Timer ──────────────────────────────────────── */
  function initTimer(CFG) {
    if (!CFG.timerEnabled) return;
    var atcBtn = $q('[id^="npp-atc-"]');
    if (!atcBtn) return;
    
    document.querySelectorAll('.npp-cro-timer').forEach(function(t) { t.remove(); });
    
    var end = parseInt(sessionStorage.getItem(CFG.timerKey)||'0',10);
    if (!end || end < Date.now()) {
      end = Date.now() + CFG.timerMin * 60000;
      sessionStorage.setItem(CFG.timerKey, end);
    }
    var el = document.createElement('div');
    el.className = 'npp-cro-timer';
    el.innerHTML =
      '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16.5 14.5"/></svg>' +
      '<span>' + CFG.timerLabel + '</span><b class="npp-cro-count"></b>';
    var row = atcBtn.closest('.npp-atc-row') || atcBtn.parentElement;
    var par = row && row.parentElement;
    if (par) par.insertBefore(el, row);
    var cnt = el.querySelector('.npp-cro-count');
    (function tick(){
      var rem = Math.max(0, Math.floor((end - Date.now())/1000));
      if (cnt) cnt.textContent = String(Math.floor(rem/60)).padStart(2,'0') + ':' + String(rem%60).padStart(2,'0');
      if (rem > 0) setTimeout(tick, 1000);
    })();
  }

  /* ── 3. Social Proof Popup ─────────────────────────────────── */
  function initProof(CFG) {
    if (!CFG.proofEnabled) return;
    var pop = document.createElement('div');
    pop.className = 'npp-cro-proof';
    pop.setAttribute('aria-live','polite');
    pop.innerHTML =
      '<div class="npp-cro-proof-ico"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg></div>' +
      '<div class="npp-cro-proof-txt"><b class="npp-cro-pn"></b><span class="npp-cro-pp"></span><small class="npp-cro-pt"></small></div>' +
      '<button class="npp-cro-proof-x" aria-label="Close">✕</button>';
    if (CFG.rootEl) {
      CFG.rootEl.appendChild(pop);
    } else {
      document.body.appendChild(pop);
    }
    pop.querySelector('.npp-cro-proof-x').addEventListener('click', function(){ pop.classList.remove('npp-cro-in'); });
    function show(){
      pop.querySelector('.npp-cro-pn').textContent = $r(CFG.names) + ' just bought:';
      pop.querySelector('.npp-cro-pp').textContent = $r(CFG.products);
      pop.querySelector('.npp-cro-pt').textContent = $r(CFG.times);
      pop.classList.add('npp-cro-in');
      setTimeout(function(){ pop.classList.remove('npp-cro-in'); }, CFG.proofDuration);
    }
    setTimeout(function(){ show(); setInterval(show, CFG.proofInterval); }, CFG.proofDelay);
  }

  /* ── 4. ATC Animation ──────────────────────────────────────── */
  function initAtcAnim(CFG) {
    var root = $q('[data-npp-section]');
    if (!root) return;
    root.addEventListener('submit', function(e){
      var form = e.target;
      if (!form || !form.action || form.action.indexOf('/cart') === -1) return;
      var btn = form.querySelector('[type="submit"]');
      if (!btn || btn.disabled) return;
      
      // ── Shopify Analytics & Apps: AddToCart ───────────────────────
      try {
        if (window.ShopifyAnalytics && window.ShopifyAnalytics.lib) {
          window.ShopifyAnalytics.lib.track('Added product');
        }
        // Universal event for apps like Clarity and UpCart
        document.dispatchEvent(new CustomEvent('cart:add', { 
          bubbles: true,
          detail: {
            variant_id: form.querySelector('[name="id"]')?.value,
            quantity: form.querySelector('[name="quantity"]')?.value || 1
          }
        }));
        // Notify Shopify of the cart change
        if (window.Shopify && window.Shopify.onItemAdded) {
          window.Shopify.onItemAdded();
        }
      } catch(e) {}
      // ─────────────────────────────────────────────────────────────

      // ── Meta Pixel: AddToCart (product page) ─────────────────────
      try {
        var pidEl = form.querySelector('[name="id"]');
        var qtyEl = form.querySelector('[name="quantity"]');
        var vId = (pidEl && pidEl.value) ? String(pidEl.value) : '';
        var num = (qtyEl && qtyEl.value) ? parseInt(qtyEl.value, 10) : 1;
        
        // --- Deduplication Lock ---
        window._fbqLastFire = window._fbqLastFire || {};
        var now = Date.now();
        if (window._fbqLastFire[vId] && (now - window._fbqLastFire[vId] < 2000)) {
          console.debug('[Deduplication] Prevented duplicate AddToCart for:', vId);
          return;
        }
        window._fbqLastFire[vId] = now;
        // ---------------------------

        if (vId && typeof window.fbq === 'function') {
          window.fbq('track', 'AddToCart', {
            content_type : 'product',
            content_ids  : [vId],
            num_items    : num,
            currency     : (window.Shopify && window.Shopify.currency) ? window.Shopify.currency.active : 'EUR'
          });
        }
      } catch(e) {}
      // ─────────────────────────────────────────────────────────────

      var orig = btn.textContent.trim();
      btn.classList.add('npp-cro-adding');
      setTimeout(function(){
        btn.textContent = CFG.atcSuccess;
        btn.classList.remove('npp-cro-adding');
        btn.classList.add('npp-cro-added');
        setTimeout(function(){ btn.textContent = orig; btn.classList.remove('npp-cro-added'); }, CFG.atcDuration);
      }, 500);
    });
  }

  /* ── 5. Mobile Sticky Early Show ───────────────────────────── */
  function initMobileSticky(CFG) {
    if (window.innerWidth >= 750) return;
    var bar = $q('[id^="npp-sticky-"]');
    if (!bar) return;
    setTimeout(function(){ bar.classList.add('visible'); bar.setAttribute('aria-hidden','false'); }, CFG.stickyDelay);
  }

  /* ── Boot ──────────────────────────────────────────────────── */
  function boot() {
    if (!$q('[data-npp-section]')) return;
    var CFG = buildCFG();
    initProgressBar(CFG);
    initTimer(CFG);
    initProof(CFG);
    initAtcAnim(CFG);
    // initMobileSticky(CFG); // Disabled per request: rely solely on IntersectionObserver
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', function(){ setTimeout(boot, 120); });
}());

window.nppOpenVs = function(el) {
    var srcVid = el.querySelector('video');
    if (!srcVid) return;
    var modal = document.getElementById('npp-vs-modal');
    var wrap = document.getElementById('npp-vs-player-wrap');
    if (!modal || !wrap) return;
    
    var p = document.createElement('video');
    p.innerHTML = srcVid.innerHTML; 
    p.controls = true;
    p.playsInline = true;
    p.autoplay = true;
    p.muted = false;
    
    wrap.innerHTML = '';
    wrap.appendChild(p);
    
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    
    setTimeout(function(){
        p.play().catch(function(e){ console.log("npp video autoplay blocked:", e); });
    }, 50);
};

window.nppCloseVsM = function() {
    var modal = document.getElementById('npp-vs-modal');
    var wrap = document.getElementById('npp-vs-player-wrap');
    if (wrap) wrap.innerHTML = '';
    if (modal) modal.style.display = 'none';
    document.body.style.overflow = '';
};

/* ── SIZE GUIDE ENHANCEMENTS ── */
document.addEventListener("DOMContentLoaded", function() {
    // 1. Remove default values and set proper placeholders
    document.querySelectorAll('input[id^="npp-sg-ft-"]').forEach(function(el) { el.value = ''; el.placeholder = 'ft'; });
    document.querySelectorAll('input[id^="npp-sg-in-"]').forEach(function(el) { el.value = ''; el.placeholder = 'in'; });
    document.querySelectorAll('input[id^="npp-sg-lbs-"]').forEach(function(el) { el.value = ''; el.placeholder = 'lbs'; });
    document.querySelectorAll('input[id^="npp-sg-cm-"]').forEach(function(el) { el.value = ''; el.placeholder = 'cm'; });
    document.querySelectorAll('input[id^="npp-sg-kg-"]').forEach(function(el) { el.value = ''; el.placeholder = 'kg'; });

    // 2. Hide placeholder on focus, restore on blur
    document.querySelectorAll('input[id^="npp-sg-"]').forEach(function(el) {
        el.addEventListener('focus', function() { this.dataset.ph = this.placeholder; this.placeholder = ''; });
        el.addEventListener('blur', function() { this.placeholder = this.dataset.ph || ''; });
        // Clear inline errors on input
        el.addEventListener('input', function() {
            var err = this.parentNode.querySelector('.npp-sg-error');
            if (err) err.remove();
        });
    });
});

// 3. Overwrite calculation logic to implement exact requested chart and validation
var originalNppSgCalculate = window.nppSgCalculate;
window.nppSgCalculate = function(sid) {
    // Clear all existing errors
    document.querySelectorAll('.npp-sg-error').forEach(function(e) { e.remove(); });
    
    var isImp = document.getElementById('npp-sg-imp-btn-'+sid).style.background !== 'none';
    var ftEl = document.getElementById('npp-sg-ft-'+sid);
    var inEl = document.getElementById('npp-sg-in-'+sid);
    var lbsEl = document.getElementById('npp-sg-lbs-'+sid);
    var cmEl = document.getElementById('npp-sg-cm-'+sid);
    var kgEl = document.getElementById('npp-sg-kg-'+sid);
    
    var valid = true;
    function showError(el, msg) {
        var err = document.createElement('div');
        err.className = 'npp-sg-error';
        err.style.color = '#dc2626';
        err.style.fontSize = '12px';
        err.style.marginTop = '4px';
        err.innerText = msg;
        el.parentNode.appendChild(err);
        valid = false;
    }

    var ft, in_, lbs;
    if (isImp) {
        if (!ftEl.value || isNaN(parseFloat(ftEl.value))) showError(ftEl, 'Required');
        if (!inEl.value || isNaN(parseFloat(inEl.value))) showError(inEl, 'Required');
        if (!lbsEl.value || isNaN(parseFloat(lbsEl.value))) showError(lbsEl, 'Required');
        if (!valid) return;
        
        ft = parseFloat(ftEl.value);
        in_ = parseFloat(inEl.value);
        lbs = parseFloat(lbsEl.value);
    } else {
        if (!cmEl.value || isNaN(parseFloat(cmEl.value))) showError(cmEl, 'Required');
        if (!kgEl.value || isNaN(parseFloat(kgEl.value))) showError(kgEl, 'Required');
        if (!valid) return;
        
        var cm = parseFloat(cmEl.value);
        var kg = parseFloat(kgEl.value);
        var totalInches = cm / 2.54;
        ft = Math.floor(totalInches / 12);
        in_ = totalInches % 12;
        lbs = kg * 2.20462;
    }

    var rawH = ft * 12 + in_;
    var h = Math.round(rawH); // rounding handles height exact border (e.g. 67.5 -> 68)
    var size = "Unknown";
    
    if (h <= 67) { 
        if (lbs < 150.5) size = "S";
        else size = "M";
    } else if (h >= 68 && h <= 72) { 
        if (lbs < 150.5) size = "S";
        else if (lbs < 185.5) size = "M";
        else if (lbs < 210.5) size = "L";
        else if (lbs < 250.5) size = "XL";
        else if (lbs < 285.5) size = "2XL";
        else size = "3XL";
    } else if (h === 73 || h === 74) { 
        if (lbs < 185.5) size = "M";
        else if (lbs < 210.5) size = "L";
        else if (lbs < 250.5) size = "XL";
        else if (lbs < 285.5) size = "2XL";
        else size = "3XL";
    } else if (h >= 75) { 
        if (lbs < 210.5) size = "L";
        else if (lbs < 250.5) size = "XL";
        else if (lbs < 285.5) size = "2XL";
        else size = "3XL";
    }

    // Extract dynamic configurable counts from the original template-injected function
    var oldFuncStr = originalNppSgCalculate ? originalNppSgCalculate.toString() : "";
    var counts = {
        "S": (oldFuncStr.match(/"S":\s*"([^"]+)"/) || [])[1] || "1,245",
        "M": (oldFuncStr.match(/"M":\s*"([^"]+)"/) || [])[1] || "4,892",
        "L": (oldFuncStr.match(/"L":\s*"([^"]+)"/) || [])[1] || "5,102",
        "XL": (oldFuncStr.match(/"XL":\s*"([^"]+)"/) || [])[1] || "3,411",
        "2XL": (oldFuncStr.match(/"2XL":\s*"([^"]+)"/) || [])[1] || "1,894",
        "3XL": (oldFuncStr.match(/"3XL":\s*"([^"]+)"/) || [])[1] || "943"
    };
    
    document.getElementById('npp-sg-result-'+sid).innerText = size;
    document.getElementById('npp-sg-count-'+sid).innerText = counts[size] || "1,000+";

    document.getElementById('npp-sg-screen-1-'+sid).style.display = 'none';
    document.getElementById('npp-sg-screen-2-'+sid).style.display = 'block';
};

